import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';

@Component({
  selector: 'app-resend-email',
  templateUrl: './resend-email.component.html',
  styleUrls: ['./resend-email.component.scss']
})
export class ResendEmailComponent implements OnInit {
  resendForm!: FormGroup;

  submitted = false;
  loading = false;

  constructor(
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.resendForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }


  get form(): { [key: string]: AbstractControl } {
    return this.resendForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.resendForm.invalid) {
      return;
    }

    this.loading = true;
    this.authService.resendVerification(this.resendForm.value).subscribe({
      next: (data: any) => {
        this.loading = false;
        this.authService.onAuthSuccess(data);
        this.authService.setAuthUser(data);
        this.sweetAlertService.toastSuccess('Mail envoyé avec succès !', 3000);
        this.closeModal();
        this.router.navigate(['/auth/signin']);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false
        this.authService.onAuthFailure(error);
        this.sweetAlertService.toastError('Erreur !', 5000, (error.error.detail || error.error.error) || 'Le service est temporairement indisponible');
      },
    });
  }

  resetForm() {
    this.resendForm.reset();
    Object.keys(this.resendForm.controls).forEach(c => {
      this.resendForm.controls[c].setErrors(null);
    });
  }

  closeModal() {
    this.resetForm();
    this.bsModalRef.hide();
  }
}
